import { NgModule } from '@angular/core';

import { AutocompleteNoOptionsDirective } from './autocomplete-no-options.directive';
import { AutocompleteOptionDirective } from './autocomplete-option.directive';
import { AutocompleteComponent } from './autocomplete.component';

@NgModule({
  imports: [
    AutocompleteComponent,
    AutocompleteOptionDirective,
    AutocompleteNoOptionsDirective,
  ],
  exports: [
    AutocompleteComponent,
    AutocompleteOptionDirective,
    AutocompleteNoOptionsDirective,
  ],
})
export class AutocompleteModule {}
